export default {
  "gemExchangeMallAdmin.thead.index": "#NO",
  "gemExchangeMallAdmin.thead.sortWeight": "SortWeight",
  "gemExchangeMallAdmin.thead.gemMallId": "GemMallId",
  "gemExchangeMallAdmin.thead.goodsId": "GoodsId",
  "gemExchangeMallAdmin.thead.gem_goods_tags": "Tags",
  "gemExchangeMallAdmin.thead.goodsName": "GoodsName",
  "gemExchangeMallAdmin.thead.goodsImg": "GoodsImg",
  "gemExchangeMallAdmin.thead.gem_goods_type": "GemGoodsType",
  "gemExchangeMallAdmin.thead.exchangeGemQuantity": "ExchangeGemQuantity",
  "gemExchangeMallAdmin.thead.exchangeGoodsQuantity": "ExchangeGoodsQuantity",
  "gemExchangeMallAdmin.thead.exchangeLimitPerUser": "ExchangeLimitPerUser",
  "gemExchangeMallAdmin.thead.stocks": "Stocks",
  "gemExchangeMallAdmin.thead.tips": "Tips",
  "gemExchangeMallAdmin.thead.tipsPlaceholder": "No returns after redemption",
  "gemExchangeMallAdmin.thead.remarkTips": "RemarkTips",
  "gemExchangeMallAdmin.thead.remarkTipsPlaceholder": "Yellow clothes, size XL",
  "gemExchangeMallAdmin.thead.activeState": "ActiveState",
  "gemExchangeMallAdmin.thead.createdAt": "CreatedAt",
  "gemExchangeMallAdmin.thead.updatedAt": "UpdatedAt",

  "gemExchangeMallAdmin.thead.action": "Action",
  "gemExchangeMallAdmin.add": "Add",
  "gemExchangeMallAdmin.edit": "Edit",
  "gemExchangeMallAdmin.details": "Details",
  "gemExchangeMallAdmin.delete": "Delete",
};
